type Props = {
    color?: string;
    width?: number;
    height?: number;
};

export default function IconPlayCircleFilled({
    color = 'white',
    width = 64,
    height = 64,
}: Props) {
    return (
<svg width={width} height={height} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M28.4 41.9999L41.4 33.6666C42.0222 33.2666 42.3333 32.711 42.3333 31.9999C42.3333 31.2888 42.0222 30.7333 41.4 30.3333L28.4 21.9999C27.7333 21.5555 27.0555 21.5221 26.3666 21.8999C25.6778 22.2777 25.3333 22.8666 25.3333 23.6666V40.3333C25.3333 41.1333 25.6778 41.7221 26.3666 42.0999C27.0555 42.4777 27.7333 42.4444 28.4 41.9999ZM32 58.6666C28.3111 58.6666 24.8444 57.9666 21.6 56.5666C18.3555 55.1666 15.5333 53.2666 13.1333 50.8666C10.7333 48.4666 8.83331 45.6444 7.43331 42.3999C6.03331 39.1555 5.33331 35.6888 5.33331 31.9999C5.33331 28.311 6.03331 24.8444 7.43331 21.5999C8.83331 18.3555 10.7333 15.5333 13.1333 13.1333C15.5333 10.7333 18.3555 8.83325 21.6 7.43325C24.8444 6.03325 28.3111 5.33325 32 5.33325C35.6889 5.33325 39.1555 6.03325 42.4 7.43325C45.6444 8.83325 48.4666 10.7333 50.8666 13.1333C53.2666 15.5333 55.1666 18.3555 56.5667 21.5999C57.9666 24.8444 58.6666 28.311 58.6666 31.9999C58.6666 35.6888 57.9666 39.1555 56.5667 42.3999C55.1666 45.6444 53.2666 48.4666 50.8666 50.8666C48.4666 53.2666 45.6444 55.1666 42.4 56.5666C39.1555 57.9666 35.6889 58.6666 32 58.6666Z" fill={color}
></path></svg>
    );
}
